import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M50.1797 8.57432C50.0358 8.57432 50.0605 8.53003 49.9262 8.50364C49.5665 8.43297 48.9567 8.22096 48.3092 8.00894C47.0142 7.51425 45.4315 6.73686 44.2085 5.46478C42.9854 4.26336 42.1941 2.92061 41.7624 1.86053C41.5466 1.29516 41.4027 0.871135 41.2588 0.517779C41.1869 0.376436 41.1869 0.235093 41.1869 0.164422C41.1869 0.0937503 41.1869 0.09375 41.1869 0.09375C41.1869 0.09375 41.1869 0.0937501 40.1077 0.305764C39.0286 0.517778 39.0286 0.517779 39.0286 0.517779C39.0286 0.517779 39.0286 0.517778 39.0286 0.58845C39.0286 0.58845 39.0286 0.659121 39.0286 0.729792C39.0286 0.871135 39.1006 1.01248 39.1725 1.22449C39.3164 1.64852 39.4603 2.14322 39.748 2.77926C40.3236 4.05135 41.1869 5.67679 42.6977 7.09022C43.2732 7.65559 43.9207 8.15029 44.5682 8.57432H0.179688V11.4012H44.7121C43.9926 11.8252 43.2732 12.3906 42.5538 13.0973C41.1149 14.5107 40.1797 16.2068 39.6041 17.4082C39.3164 18.0443 39.1725 18.6097 39.0286 18.963C38.9567 19.175 38.9567 19.3164 38.8847 19.4577C38.8847 19.5284 38.8847 19.5284 38.8847 19.5991C38.8847 19.5991 38.8847 19.5991 38.8847 19.6697C38.8847 19.6697 38.8847 19.6697 39.9639 19.8817C41.043 20.0938 41.043 20.0938 41.043 20.0938V20.0231C41.043 19.9524 41.1149 19.8111 41.1149 19.6697C41.1869 19.3164 41.4027 18.8923 41.6185 18.327C42.1221 17.2669 42.8416 15.8535 44.0646 14.7227C45.2876 13.4506 46.8703 12.6733 48.1653 12.1786C48.8128 11.9665 49.3883 11.7545 49.748 11.6839C49.9639 11.6132 50.1077 11.6132 50.1797 11.6132V10.9771V9.3517V8.57432Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'slider-arrow-right',
  props: {
  color: { type: String, required: true },
},
  setup(__props) {

// eslint-disable-next-line no-undef


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "51",
    height: "21",
    viewBox: "0 0 51 21",
    fill: __props.color,
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})